import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueSilentbox from "vue-silentbox";
import { initLandingAnalytics } from "./utils/analytics";

import 'vue-silentbox/dist/style.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap'
import '../src/assets/css/fontawesome-all.min.css'
import 'animate.css/animate.min.css'
import '../src/assets/scss/style.scss'

initLandingAnalytics(router);

// Keep the build-time content visible until the initial route is ready.
const app = createApp(App).use(router).use(VueSilentbox);
router.isReady().then(() => app.mount("#app"));
